module.exports = __webpack_public_path__ + "static/media/guaranteed-irish.76ef314c.png";